import { useNavigate } from 'react-router-dom';
import styles from './Dashboard.module.css';

const cards = [
  { icon: '📂', label: 'Categories',     path: '/categories',     color: '#6c63ff' },
  { icon: '📋', label: 'Subcategories',  path: '/subcategories',  color: '#43b89c' },
  { icon: '🖼️', label: 'Banners',        path: '/banners',        color: '#ec4899' },
  { icon: '💎', label: 'Packages',       path: '/packages',       color: '#7c3aed' },
  { icon: '📢', label: 'Ads',            path: '/ads',            color: '#f59e0b' },
  { icon: '🚩', label: 'Reports',        path: '/reports',        color: '#ef4444' },
  { icon: '👥', label: 'Users',          path: '/users',          color: '#0ea5e9' },
  { icon: '🚫', label: 'Blocked',        path: '/blocked',        color: '#64748b' },
  { icon: '🔔', label: 'Notifications',  path: '/notifications',  color: '#8b5cf6' },
  { icon: '⚙️', label: 'Settings',       path: '/settings',       color: '#475569' },
  { icon: '🎧', label: 'Support',        path: '/support',        color: '#10b981' },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');

  return (
    <div>
      <h2 className={styles.welcome}>Welcome back, {admin.name || 'Admin'} 👋</h2>
      <div className={styles.grid}>
        {cards.map((c) => (
          <div
            key={c.path}
            className={styles.card}
            style={{ background: c.color }}
            onClick={() => navigate(c.path)}
          >
            <span className={styles.cardIcon}>{c.icon}</span>
            <span className={styles.cardLabel}>{c.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
